/**
 * Neyra — catalog data.
 *
 * NOTE (Phase 1 refinement): All demo / fake content has been removed.
 * Events, services and people now come exclusively from real user data
 * stored in the entity stores. The empty arrays below are kept so callers
 * that import them continue to compile without changes.
 */

export const MOCK_EVENTS = [];
export const MOCK_SERVICES = [];
export const MOCK_PEOPLE = [];

/** Deterministic avatar color for a given string (stable across renders). */
export const avatarColorFor = (seed = "") => {
    let h = 0;
    for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
    const hue = h % 360;
    return `hsl(${hue}, 70%, 55%)`;
};

export const initialsFor = (name = "") =>
    name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((s) => s[0]?.toUpperCase() || "")
        .join("");

/** Cross-entity search — operates over real entities loaded by callers. */
export const searchAll = (query) => {
    const q = String(query || "").trim().toLowerCase();
    if (!q) return { events: [], services: [], people: [] };
    return { events: [], services: [], people: [] };
};

export const DEFAULT_LOCATION = { city: "Lagos", country: "Nigeria" };
